/**
 * capitalize a string.
 * @param str
 * @returns
 */
export const capitalizeText = (str = '') => {
  return str
    ?.toLowerCase()
    ?.replace(/(\b[a-z](?!\s))/g, (letter) => letter?.toUpperCase());
};

export const isValidSerialNumber = (inputSn = '') => {
  if (inputSn?.length !== 8) return false;
  const firstThree = inputSn.slice(0, 3);
  const lastFive = inputSn.slice(3);
  const alphaNumPattern = /^[A-Za-z0-9]{3}$/;
  const mustContainAlphabetPattern = /[A-Za-z]/;
  const numericPattern = /^\d{5}$/;

  return (
    alphaNumPattern.test(firstThree) &&
    mustContainAlphabetPattern.test(firstThree) &&
    numericPattern.test(lastFive)
  );
};
